import React, { useState } from 'react';

function normalizeName(s) {
  return (s || '')
    .toLowerCase()
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')
    .slice(0, 48);
}

export default function SimpleFieldEditor({ field, onChange }) {
  const [showAdv, setShowAdv] = useState(false);
  const set = (patch) => onChange?.(patch);

  const ensureName = (labelOrText) => {
    if (!field?.name && labelOrText) set({ name: normalizeName(labelOrText) });
  };

  const isOptions = ['radio', 'select', 'checkbox_group'].includes(field.type);

  const addOption = () => set({ options: [ ...(field.options || []), { value: '', label: '' } ] });
  const updOption = (i, patch) => {
    const next = [ ...(field.options || []) ];
    next[i] = { ...(next[i] || {}), ...patch };
    set({ options: next });
  };
  const delOption = (i) => {
    const next = [ ...(field.options || []) ];
    next.splice(i, 1);
    set({ options: next });
  };

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 180px', gap: 12 }}>
        <div>
          {field.type === 'consent' ? (
            <>
              <label>Einwilligungstext (HTML erlaubt)</label>
              <textarea
                rows={3}
                value={field.html ?? field.text ?? ''}
                onChange={e => set({ html: e.target.value })}
                onBlur={e => ensureName(e.target.value)}
              />
              <div style={{ marginTop: 6 }}>
                <button
                  className="secondary"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    set({
                      html: 'Ich habe die <a href="https://digitecstudieren.de/datenschutz.html" target="_blank" rel="noopener">Datenschutzerklärung</a> zur Kenntnis genommen.'
                    });
                  }}
                >
                  Vorlage „Datenschutzerklärung“ einsetzen
                </button>
              </div>
            </>
          ) : (
            <>
              <label>Label (angezeigt)</label>
              <input
                value={field.label || ''}
                onChange={e => set({ label: e.target.value })}
                onBlur={e => ensureName(e.target.value)}
              />
            </>
          )}
        </div>
        <div>
          <label>Pflichtfeld</label>
          <select
            value={field.required ? '1' : '0'}
            onChange={e => set({ required: e.target.value === '1' })}
          >
            <option value="0">Nein</option>
            <option value="1">Ja</option>
          </select>
        </div>
      </div>

      {/* Placeholder für text/email/phone/textarea */}
      {(field.type === 'text' || field.type === 'email' || field.type === 'phone' || field.type === 'textarea') && (
        <>
          <label>Placeholder (optional)</label>
          <input
            value={field.placeholder || ''}
            onChange={e => set({ placeholder: e.target.value })}
          />
        </>
      )}

      {/* Optionen für Radio/Select/Checkbox-Gruppe */}
      {isOptions && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
            <label style={{ margin: 0 }}>Optionen</label>
            <button className="secondary" type="button" onClick={addOption}>+ Option</button>
          </div>
          <div style={{ display: 'grid', gap: 8 }}>
            {(field.options || []).map((o, i) => (
              <div key={i} className="card" style={{ padding: 8, display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 8 }}>
                <div>
                  <small className="muted">Wert</small>
                  <input value={o.value || ''} onChange={e => updOption(i, { value: e.target.value })} />
                </div>
                <div>
                  <small className="muted">Beschriftung</small>
                  <input value={o.label || ''} onChange={e => updOption(i, { label: e.target.value })} />
                </div>
                <div style={{ alignSelf: 'end' }}>
                  <button className="link" type="button" onClick={() => delOption(i)}>🗑</button>
                </div>
              </div>
            ))}
            {(field.options || []).length === 0 && <div className="muted">Noch keine Optionen.</div>}
          </div>
        </div>
      )}

      <details open={showAdv} onToggle={e => setShowAdv(e.currentTarget.open)}>
        <summary>Erweitert</summary>
        <div style={{ marginTop: 8, display: 'grid', gap: 8 }}>
          <div>
            <label>Feldname (technisch)</label>
            <input value={field.name || ''} onChange={e => set({ name: e.target.value })} />
            <small className="muted">Schlüssel im Export / in der DB</small>
          </div>

          {/* Zeilenanzahl nur für Textarea */}
          {field.type === 'textarea' && (
            <div>
              <label>Zeilen</label>
              <input
                type="number"
                min="2"
                max="12"
                value={field.rows || 3}
                onChange={e => set({ rows: Number(e.target.value) || 3 })}
              />
            </div>
          )}

          {/* Optionales Pattern für Phone */}
          {field.type === 'phone' && (
            <div>
              <label>Pattern (RegEx, optional)</label>
              <input
                placeholder="z. B. ^\\+?[0-9\\s\\-()]{6,20}$"
                value={field.pattern || ''}
                onChange={e => set({ pattern: e.target.value })}
              />
              <small className="muted">Leer lassen = keine zusätzliche Client-Validierung.</small>
            </div>
          )}

          <div>
            <label>Duplizieren</label><br />
            <button
              className="secondary"
              type="button"
              onClick={(e) => { e.preventDefault(); onChange?.({ __duplicate: true }); }}
            >
              Dieses Feld duplizieren
            </button>
            <small className="muted" style={{ display: 'block' }}>
              Duplikat erscheint in der Feldliste; Feldname bitte anpassen.
            </small>
          </div>
        </div>
      </details>
    </div>
  );
}